module.exports = "<h3 class=\"text-center padding-top\">Collections</h3>\n\n<div class=\"row padding-top padding-bottom-3x\">\n  <div class=\"col-sm-3 col-xs-6\" *ngFor=\"let collection of collections\">\n    <a class=\"category-link\"\n       [routerLink]=\"['/shop']\" [queryParams]=\"{ collection: collection.id }\">\n      <img *ngIf=\"collection.img\"\n           src=\"{{ collection.img }}\" alt=\"{{ collection.name }}\">\n      {{ collection.name }}\n    </a>\n  </div>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/Templates/collection.list.html
// module id = ./src/app/Templates/collection.list.html
// module chunks = main